import { ref, computed } from 'vue'
import urlProcessor from '@app/helpers/urlProcessor'

/**
 * Creates a data structure for using a form select field with an enum api
 * 
 * @param {String} initialAction 
 * @param {Object} initialConfig 
 * @returns {Object<action: Ref<String>, config: Ref<Object>, parameters: Ref<Object>, url: Computed<String>>}
 */
export function createEnumApi(initialAction, initialConfig = {}){

    const action = ref(initialAction)
    const config = ref(initialConfig)

    const parameters = ref({})

    return {
        action     : action,
        config     : config,
        parameters : parameters,
        url        : computed(() => {
            //@TODO: Build URL from parameters and action
            return urlProcessor(
                window.phpVals.adminAjax,
                {
                    ...parameters.value,
                    action : action.value,
                    nonce  : window.phpVals.btNonce
                }
            )
        }),
    }
}